/**
 * CaseSection displays help messages for the user having active case in the resolution center
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import l10n from '../../lib/reactPPl10nHelper';
import { trackLink } from '../../lib/analytics-helper';
import * as homeShape from '../constants/PropTypesShapes';
import Page from '../../lib/page';

const dataSet = {
  dispute: {
    checkMessage: l10n.getContent('smarthelp/info.info.casesection.dispute.checkMessage'),
    label: l10n.getContent('smarthelp/info.info.casesection.dispute.ResolutionLink'),
    link: 'https://www.msmaster.qa.paypal.com/disputes/',
  },
  fptiEvent: {
    click: 'clicked',
    open: 'open',
  },
};

class CaseSection extends Component {
  // Send FPTI for dispute section for both case-section open and clicked
  static FPTIHandler(event) {
    trackLink({ id: 'articlePage', link: `smarthelp-dispute|${event}` });
  }

  static renderResolutionLink() {
    return (<a
      className="dispute-message-link"
      onClick={() => CaseSection.FPTIHandler(dataSet.fptiEvent.click)}
      href={dataSet.dispute.link}
      rel="noopener noreferrer"
      target="_blank"
    >{dataSet.dispute.label}</a>);
  }

  static renderDisputeMsg() {
    const disputeViewMsg = l10n.getContent('smarthelp/info.info.casesection.dispute.viewCase',
    { ViewResolution: CaseSection.renderResolutionLink() });
    return (
      <div className="dispute-message-container">
        <span className="dispute-message-checker">{dataSet.dispute.checkMessage}</span>
        <span className="dispute-message-view">{disputeViewMsg}</span>
      </div>);
  }

  componentDidMount() {
    if (this.isOpenCase()) {
      CaseSection.FPTIHandler(dataSet.fptiEvent.open);
    }
  }

  // return true, when the login user have resolution center open cases
  isOpenCase() {
    const isDisputeFAQ = Page.isDisputeArticle(this.props.articleTitle);
    return Array.isArray(this.props.cases) && this.props.cases.length > 0 && isDisputeFAQ;
  }

  render() {
    if (!this.isOpenCase()) {
      return null;
    }

    return (
      <div className="case-section-container">
        {CaseSection.renderDisputeMsg()}
      </div>
    );
  }
}

CaseSection.propTypes = {
  articleTitle: PropTypes.string,
  cases: PropTypes.shape(homeShape.OPEN_CASE),
};

CaseSection.defaultProps = {
  articleTitle: '',
  cases: [],
};

export default CaseSection;
